import { DefaultEffects, Panel, PanelType, TextField } from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../components/Panel/PanelFooter";
import { useAddTipoEquipo } from "../../../hooks/TiposEquipos/useAddTipoEquipo";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import { IPostCrearTipoEquipo } from "../../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";
interface IPanelAddTipoEquipo {
  isOpen: boolean;
  onDismiss: () => void;
  onRefreshTable: () => void;
}

export const PanelAddTipoEquipo = (props: IPanelAddTipoEquipo) => {
  const [request, setRequest] = useState<IPostCrearTipoEquipo>(null!);

  const { ocultarMensaje, response, isSend, PostCrearTipoEquipo } =
    useAddTipoEquipo();

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="add"
          textHeader={`Tipo Equipo`}
          subTextHeader={`Agregar Tipo de Equipo`}
        />
      </>
    ),
    []
  );
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Agregar"
          onClick={() => {
            PostCrearTipoEquipo(request);
          }}
          onDismiss={() => {
            props.onDismiss();
          }}
        />
      </>
    ),
    [PostCrearTipoEquipo, request]
  );

  const onChangeTextField = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    valor?: string
  ) => {
    if (event !== undefined && valor !== undefined) {
      setRequest({ nombre: valor });
    }
  };
  useEffect(() => {
    if (!props.isOpen) {
      ocultarMensaje();
      props.onRefreshTable();
      setRequest({ nombre: "" });
    }
  }, [props.isOpen]);

  return (
    <>
      <Panel
        type={PanelType.smallFixedFar}
        onRenderHeader={onRenderHeader}
        onRenderFooter={onRenderFooter}
        isFooterAtBottom
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
      >
        <>
          <MensajeBar
            response={response}
            ocultar={() => {
              ocultarMensaje();
            }}
          />
          {isSend == true ? (
            <IdicadorProgress isSend={isSend} subText="Espere un momento..." />
          ) : (
            <div className="ms-Grid" dir="ltr">
              <div
                style={{
                  margin: "30px 0px",
                  width: "100%",
                  height: "auto",
                  padding: "15px 0px",
                }}
              >
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <br />
                    <TextField
                      label="Tipo Equipo:"
                      underlined
                      required
                      placeholder="Escribir aquí"
                      onChange={onChangeTextField}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      </Panel>
    </>
  );
};
